var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("sidebar-widget", {
    staticClass: "sidebar-views",
    attrs: {
      id: "views-widget",
      title: _vm.$gettext("Ansicht"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "ul",
              {
                staticClass: "widget-list widget-links sidebar-views",
              },
              [
                _c(
                  "li",
                  {
                    class: {
                      active: _vm.config.view === "list",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getUrl("list"),
                          title: _vm.$gettext("Verzeichnis als Liste anzeigen"),
                          tabindex: "0",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Als Liste anzeigen")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: {
                      active: _vm.config.view === "table",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getUrl("table"),
                          title: _vm.$gettext(
                            "Verzeichnis als Tabelle anzeigen"
                          ),
                          tabindex: "0",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Als Tabelle anzeigen")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }